/*
 * ew-livery-reflavor.js — Covert merchandising reorder (A3 revised, item 7)
 *
 * When a livery is active, featured product rows silently reorder so
 * the livery's priority products lead. Driven entirely by the active
 * livery's `merchandising_rules` (a {types,tags,vendors} object stored
 * on the livery metaobject). No labels, no badges, no "recommended for
 * X" — the visible change is the reskin; this shift is unannounced.
 *
 * Reorders the immediate product-card children of any container with
 * [data-ew-livery-reorder]. Scores each card from its
 * data-product-type / data-product-vendor / data-product-tags attrs.
 * Neutral (no livery) restores the server-rendered order.
 *
 * Replaces ew-persona-reflavor.js. (The per-persona copy-swap from the
 * old A3 is intentionally dropped — the revised model keeps copy
 * constant; only the reskin + silent reorder change.)
 */
(function () {
  'use strict';

  function scoreCard(card, rules) {
    if (!rules) return 0;
    var type   = (card.getAttribute('data-product-type')   || '').toLowerCase();
    var vendor = (card.getAttribute('data-product-vendor') || '').toLowerCase();
    var tags   = (card.getAttribute('data-product-tags')   || '').toLowerCase()
                   .split(',').map(function (s) { return s.trim(); });
    var score = 0;
    (rules.types   || []).forEach(function (t) { if (type === String(t).toLowerCase()) score += 10; });
    (rules.vendors || []).forEach(function (v) { if (vendor.indexOf(String(v).toLowerCase()) !== -1) score += 8; });
    (rules.tags    || []).forEach(function (t) { if (tags.indexOf(String(t).toLowerCase()) !== -1) score += 5; });
    return score;
  }

  function reorderContainer(container, rules) {
    var cards = Array.prototype.slice.call(container.children).filter(function (el) {
      return el.matches && el.matches('a, button, div, li');
    });
    if (cards.length < 2) return;
    cards.forEach(function (c, i) { if (c.__ewOrigIdx == null) c.__ewOrigIdx = i; });
    if (!rules) {
      cards.sort(function (a, b) { return a.__ewOrigIdx - b.__ewOrigIdx; });
    } else {
      cards.sort(function (a, b) {
        var sa = scoreCard(a, rules), sb = scoreCard(b, rules);
        if (sb !== sa) return sb - sa;
        return a.__ewOrigIdx - b.__ewOrigIdx;  /* stable */
      });
    }
    cards.forEach(function (c) { container.appendChild(c); });
  }

  function applyAll(liveryId) {
    var rules = (liveryId && window.EWLivery) ? window.EWLivery.rulesFor(liveryId) : null;
    document.querySelectorAll('[data-ew-livery-reorder]').forEach(function (c) {
      reorderContainer(c, rules);
    });
  }

  function boot() {
    applyAll(window.EWLivery ? window.EWLivery.read() : null);
  }

  document.addEventListener('ew:livery-changed', function (e) { applyAll(e.detail.livery); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.EWLiveryReflavor = { apply: applyAll, score: scoreCard };
})();
